import { Yii } from "libraries/interfaces/Yii";

export const MESSAGES = {
    getQuotationError: Yii.t('wui-shared-js', "Les prix et les disponibilités n'ont pas pu être confirmés: "),
    getHotelQuoteError: Yii.t('wui-shared-js', 'Une erreur est survenue lors du chargement: '),
    getHotelsListError: Yii.t('wui-shared-js', 'Erreur lors de la recherche, veuillez réessayer'),
    searchHotelsWarning: Yii.t('wui-shared-js', "Aucun hôtel n'a été trouvé"),
    getRoomsError: Yii.t('wui-shared-js', "Les chambres n'ont pas pu être correctement chargées: "),
    noTraveller: Yii.t('wui-watabi-js', 'Aucun voyageur saisi pour cet itinéraire.'),
    clickClose: Yii.t('wui-watabi-js',
        'Vous pouvez saisir dès maintenant les informations voyageurs en allant sur la page "Personnes".'),
    clickContinue: Yii.t('wui-watabi-js',
        "Vous pouvez faire votre recherche avec l'ajout automatique de :"),
    clickContinueWarning: Yii.t('wui-watabi-js',
        "<strong>Attention : </strong>Vous devrez saisir ultérieurement les informations voyageurs."),
};
